import React from "react";
import { useAppSelector } from "../redux/store";
import { useNavigate } from "react-router-dom";

type props = {
  cancelRequest: () => void;
};

const UrgentRequestModal = (props: props) => {
  const navigate = useNavigate();
  const booking = useAppSelector((state) => state.booking);

  const continueTheRequest = () => {
    navigate("/urgentRequest");
  };
  return (
    <div className="urgentRequestModal">
      <header>
        <strong>!!! ACHTUNG !!!</strong>
      </header>
      <main>
        <p>Bevor Sie diesen Notfall absenden, fragen Sie sich bitte selbst:</p>
        <ul>
          <li>möchten Sie uns Informationen bezüglich Zahlungen oder Reiseunterlagen geben</li>
          <li>
            liegen zwischen HEUTE und dem 1. Tag Ihrer Reise noch ein voller Werktag (Mo – Fr von
            09:00 bis 18:00)
          </li>
        </ul>
        <p>
          dann nutzen Sie bitte zunächst den unten rechts verfügbaren virtuellen Mitarbeiter „Mike“
          oder schreiben Sie eine E-Mail mit aussagekräftigem Betreff an
          partnerservice@lmx-reiseservice.de oder melden Sie sich bei Ihrem Reisebüro.
        </p>
        <p>Diese Anfrage hier muss für wirkliche Notfälle freigehalten werden. Das sind z.B.:</p>
        <ul>
          <li>dringende Infos die den Urlaub in letzter Minute vereiteln könnten</li>
          <li>Probleme beim Check-In am Flughafen oder am Urlaubsort</li>
          <li>Unfälle mit Personenschaden</li>
          <li>andere Gefahren für Leib & Leben während des Urlaubs</li>
        </ul>
      </main>

      <footer>
        <button className="btn btn-info" onClick={props.cancelRequest}>
          ABBRUCH <br />
          <strong>Ich versuche zunächst das Problem anderweitig zu lösen</strong>
        </button>
        <button className="btn btn-warning" onClick={continueTheRequest}>
          ANFRAGE ABSENDEN <br />
          <strong>Mein Problem ist ein echter Notfall gemäß o.g. Kriterien.</strong>
        </button>
      </footer>
    </div>
  );
};

export default UrgentRequestModal;
